// @flow
import * as CursorSpinner from 'fg-frontend/src/components/CursorSpinner';
// import goBack           from 'fg-frontend/webActions/goBack';
// import scrollToHref     from 'fg-frontend/webActions/scrollToHref';

export default (action) => {
	switch (action) {
		case 'hsExpand':
			return (props, e) => {
				e.preventDefault();
				CursorSpinner.pushToQueue('importHsExpand');
				import('./webActions/hsExpand').then((hsExpand) => {
					CursorSpinner.removeFromQueue('importHsExpand');
					hsExpand.default(props, e);
				});
			};
		case 'execute':
			return import('fg-frontend/src/partialUpdate/partialUpdate').then(module => module.execute);
			// return execute;
		// case 'goBack':
		// 	return goBack;
		// case 'scrollToHref':
		// 	return scrollToHref;
		default:
			console.log('Unknown action');
			return null;
	}
};



// WEBPACK FOOTER //
// ./fe/web-chtitvic/src/js/configureWebActions.js